
import { Mixins, Component } from "vue-property-decorator";
import tablePagination from "@/mixins/tablePagination";
import ETable from "@/components/ETable.vue";
import loading from "@/mixins/loading";
import resize from "@/mixins/resize";
import { cloneDeep } from "lodash"
import EditDialog from "./components/editDialog.vue";
import { getMessageList, updateMessageStatus } from "@/api/publicNumberMessage";

const baseForm = {
  wxTemplateName: "【养身帮数智健康】公众号节气",
  wxMessageTitle: "",
  wxMessageContent: "",
  status: false,
  imgUrl: [],
  remark: "",
  pushTime: "",
  receiveBy: 1
}

@Component({ name: 'publicNumberMessage-index',
  components: { ETable, EditDialog }
})
export default class selectRecommendation extends Mixins(loading, tablePagination, resize) {
  EditDialogVisible: boolean = false;
  dialogTitle = "";

  statusOptions = [
    {
      label: "启用",
      value: 1
    },
    {
      label: "禁用",
      value: 0
    }
  ]

  queryForm = {
    status: "",
    wxMessageTitle: ""
  };
  itemTotal = 0;
  tableData = [];

  columns = [
    { label: "ID", prop: "id" },
    { label: "消息标题", prop: "wxMessageTitle", minWidth: "160px" },
    { label: "模板名称", prop: "wxTemplateName", minWidth: "220px" },
    { label: "推送时间", prop: "pushTime", width: "100px" },
    { label: "接收人", prop: "receiveBy" },
    { label: "图片", prop: "imgUrl", width: "220px" },
    { label: "备注", prop: "remark" },
    { label: "编辑人", prop: "modifiedBy" },
    { label: "编辑时间", prop: "modifiedTime", width: "100px" },
    { label: "操作", prop: "action", width: "120px" }
  ]

  formData = {
    wxTemplateName: "【养身帮数智健康】公众号节气",
    wxMessageTitle: "",
    wxMessageContent: "",
    status: false,
    imgUrl: [],
    remark: "",
    pushTime: "",
    receiveBy: 1
  }

  mounted() {
    this.windowResize();
    this.getData();
  }

  searchData() {
    this.resetCurrent();
    this.getData();
  }

  getData() {
    const params = {
      pageNum: this.currentPage,
      pageSize: this.pageSize,
      ...this.queryForm,
    }
    this.showLoading();
    getMessageList(params).then((res) => {
      this.tableData = res.data.list;
      this.itemTotal = res.data.total;
    })
  }

  handleStatusChange(row) {
        updateMessageStatus({ id: row.id, status: Number(!row.status) }).then(() => {
            this.getData();
        })
    }

  handleEdit(row) {
    this.dialogTitle = row.id ? "编辑消息" : "新增消息";
    if (row.id) {
      const { status, imgUrl } = row;
      Object.assign(this.formData, { ...row, status: Boolean(status), imgUrl: imgUrl ? [{ url: imgUrl }] : [] });
    }
    else {
      this.formData = cloneDeep(baseForm);
    }
    this.EditDialogVisible = true;
  }

  editConfirm() {
    this.getData();
    this.EditDialogVisible = false;
  }
}

